import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TopdownAdjustmentNewRoutingModule } from './topdown-adjustment-new-routing.module';
import { TopdownAdjustmentNewComponent } from './topdown-adjustment-new.component';
import { FormsModule } from '@angular/forms';
import { DxDataGridModule, DxValidatorModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';


@NgModule({
  declarations: [TopdownAdjustmentNewComponent],
  imports: [
    CommonModule, FormsModule, DevEpressCommonModule, DxDataGridModule, DxValidatorModule,
    TopdownAdjustmentNewRoutingModule
  ]
})
export class TopdownAdjustmentNewModule { }
